import { ProjectQuoteApiParameter, ProjectQuoteModel, updateProjectQuote } from "@NA/Services/ADIGetQuoteDetails";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    HasOnComplete,
    HasOnSuccess,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<
    ProjectQuoteApiParameter & HasOnSuccess & HasOnComplete,
    ProjectQuoteModel
>;

export const LoadUpdateProjectQuote: HandlerType = async (props: any) => {
    props.apiResult = await updateProjectQuote({
        isProject: props.parameter.isProject,
        hasOrderNumber: props.parameter.hasOrderNumber,
        cartId: props.parameter.cartId,
        name: props.parameter.name,
        orderNumber: props.parameter.orderNumber,
        quoteNumber: props.parameter.quoteNumber,
        orderTotal: props.parameter.orderTotal,
        orderLines: props.parameter.orderLines,
        contractUid: props.parameter.contractUid,
        isQuoteCompleted: props.parameter.isQuoteCompleted,
        quoteLinecollection: props.parameter.quoteLinecollection,
    });
};

export const DispatchCompleteUpdateProjectQuote: HandlerType = props => {
    props.parameter && props.parameter.onSuccess && props.parameter?.onSuccess();
};

export const chain = [LoadUpdateProjectQuote, DispatchCompleteUpdateProjectQuote];

const updateProjectQuoteHandler = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        isProject: false,
        hasOrderNumber: false,
        cartId: '',
        name: '',
        orderNumber: '',
        quoteNumber: '',
        orderTotal: 0.0,
        orderLines: null,
        contractUid: '',
        isQuoteCompleted: '',
        quoteLinecollection: '',
        onSuccess: () => { },
        onComplete: () => { }
        // Added property is a P21 Change
    },
    "UpdateProjectQuoteHandler",
);
export default updateProjectQuoteHandler;
